import { render, staticRenderFns } from "./PosterModule.vue?vue&type=template&id=7d9a2929"
import script from "./PosterModule.vue?vue&type=script&lang=ts"
export * from "./PosterModule.vue?vue&type=script&lang=ts"
import style0 from "./PosterModule.vue?vue&type=style&index=0&id=7d9a2929&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports